<template>
    <div class="city-park">
        <el-button type="primary" size="mini" icon="el-icon-back" @click="$router.back()">返回</el-button>
        <el-divider content-position="left">城市园区管理</el-divider>
        <div style="display: flex;">
            <div style="margin-left: auto;">
                <el-button type="primary" @click.native="openTypeInDrawer" size="mini">录入</el-button>
            </div>
        </div>
        <el-table max-height="650" :data="tableData" style="width: 100%; margin-top: 10px" border size="mini"
            :header-cell-style="{
                background: '#ecf4ff',
                color: '#333',
                fontWeight: '900',
                fontSize: '0.28rem',
            }">
            <el-table-column prop="id" label="ID" width="80">
                <!-- <template slot-scope="scope">
                    <span>{{ scope.$index + 1 }}</span>
                </template> -->
            </el-table-column>
            <el-table-column prop="park" label="园区名称" align="center">
            </el-table-column>
            <el-table-column prop="desc" label="描述" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="price" label="价格" align="center">
            </el-table-column>
            <el-table-column prop="" label="图标" align="center">
                <template slot-scope="scope">
                    <div class="demo-image__preview" v-if="scope.row.icon">
                        <el-image style="width:;height:;" :src="scope.row.path" :preview-src-list="[scope.row.path]">
                        </el-image>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="是否显示">
                <template slot-scope="scope">
                    是
                    <el-switch v-model="ListIfDisplay[scope.row.id]" active-color="#ff4949" inactive-color="#13ce66"
                        @change="editListRadioC($event, scope.row.id)">
                    </el-switch>
                    否
                </template>
            </el-table-column>
            <el-table-column label="排序">
                <template slot-scope="scope">
                    <el-input :ref="'list' + scope.row.id" type="number" size="mini" v-model.trim="listSort[scope.row.id]"
                        @click.native="needId = scope.row.id"></el-input>
                </template>
            </el-table-column>
            <el-table-column prop="created_at" label="录入时间" align="center">
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="120">
                <template slot-scope="scope">
                    <el-button @click.native.prevent="editRow(scope.$index, tableData)" type="text" size="small">
                        修改
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="block" style="margin-top: 10px; text-align: right">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="npage"
                :page-sizes="[10, 15, 30, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                :total="total" background>
            </el-pagination>
        </div>

        <el-drawer title="" :visible.sync="TypeInDrawer" direction="rtl" :before-close="handleCloseTypeIn" size="70%">
            <template slot="title">
                <span style="color: #409eff; font-size: 0.3rem;font-weight: bold">{{ TypeInDrawerTitle }}</span>
            </template>
            <div style="padding: 0 0.5rem;">
                <el-form :model="TypeInForm" :rules="rules" ref="TypeInForm" label-width="80px">
                    <el-card shadow="always">
                        <div slot="header">
                            <span>园区信息</span>
                        </div>
                        <div>
                            <el-form-item label="园区名称" prop="park">
                                <el-input type="text" v-model="TypeInForm.park" size="medium" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="描述" prop="desc">
                                <el-input type="text" v-model="TypeInForm.desc" size="medium" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="价格" prop="price">
                                <el-input type="number" v-model="TypeInForm.price" size="medium" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="" prop="origin_name">
                            </el-form-item>
                        </div>
                    </el-card>
                    <el-card shadow="always" style="margin-top: 0.2rem;">
                        <div slot="header">
                            <span>其他信息</span>
                        </div>
                        <div>
                            <el-form-item label="上传图标" prop="icon">
                                <el-upload :action="uploadUrl" list-type="picture-card" :limit="1" :headers="headers"
                                    :before-upload="beforeAvatarUpload" :file-list="fileList"
                                    :on-success="handleUploadSuccess" ref="uploadicon">
                                    <i slot="default" class="el-icon-plus"></i>
                                    <div slot="file" slot-scope="{file}">
                                        <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                                        <span class="el-upload-list__item-actions">
                                            <span class="el-upload-list__item-preview"
                                                @click="handlePictureCardPreview(file)">
                                                <i class="el-icon-zoom-in"></i>
                                            </span>
                                            <span class="el-upload-list__item-delete" @click="handleRemove(file)">
                                                <i class="el-icon-delete"></i>
                                            </span>
                                        </span>
                                    </div>
                                </el-upload>
                                <el-dialog :visible.sync="dialogVisible" append-to-body>
                                    <img width="100%" :src="dialogImageUrl" alt="">
                                </el-dialog>
                            </el-form-item>
                        </div>
                    </el-card>
                    <div style="text-align: right;margin-top: 0.2rem;">
                        <el-button type="info" size="medium" @click="HandleResetForm('TypeInForm')"
                            v-if="this.TypeInDrawerTitle === '录入'">重置</el-button>
                        <el-button type="primary" size="medium" @click="HandleSubmitForm('TypeInForm')"
                            v-if="this.TypeInDrawerTitle === '录入'">提交</el-button>
                        <el-button type="primary" size="medium" @click="HandleSubmitEditForm('TypeInForm')"
                            v-else-if="this.TypeInDrawerTitle === '修改'">保存</el-button>
                    </div>
                </el-form>
            </div>
        </el-drawer>
    </div>
</template>

<script>
export default {
    name: 'CityPark',
    data() {
        var validateLength = (rule, value, callback) => {
            if (!value) {
                callback()
            } else {
                var reg = /^-?\d{1,20}(?:\.\d{1,2})?$/ // 小数点左边最高4位，小数点右边最多4位
                if (reg.test(value)) {
                    callback()
                } else {
                    callback(new Error('请输入正确的数字,小数点后可2位'))
                }
            }
        }
        return {
            tableData: [],
            pageSize: 10,
            total: 0,
            npage: 1,
            TypeInDrawer: false,
            TypeInForm: {
                park: '',
                desc: '',
                price: '',
                icon: '',
                origin_name: ''
            },
            editIndex: null,
            temUrl: null,
            needId: null,
            uploadUrl: process.env.NODE_ENV === 'development' ? 'api/api3_city_park_upload' : 'https://weixin.qiyehuo.com/api/api3_city_park_upload',
            headers: { Authorization: localStorage.token },
            dialogVisible: false,
            dialogImageUrl: null,
            fileList: [],
            ListIfDisplay: [],
            listSort: [],
            timer_sort: null,
            TypeInDrawerTitle: '录入',
            rules: {
                park: [
                    { required: true, message: '园区名称没有填写!', trigger: 'blur' },
                    { max: 50, message: '最大长度50个字符!', trigger: 'blur' },
                ],
                desc: [
                    { required: true, message: '描述没有填写!', trigger: 'blur' },
                    { max: 255, message: '最大长度255个字符!', trigger: 'blur' },
                ],
                price: [
                    { required: true, message: '价格没有填写!', trigger: 'blur' },
                    { validator: validateLength, trigger: 'blur' }
                ],
                icon: [
                    { required: true, message: '没有上传图标!', trigger: 'blur' },
                ],
            }
        }
    },
    methods: {
        openTypeInDrawer() {
            this.TypeInDrawerTitle = '录入'
            this.TypeInDrawer = true
        },
        handleCloseTypeIn(done) {
            this.$confirm('还有未保存的工作哦确定关闭吗？')
                .then(_ => {
                    if (this.TypeInDrawerTitle === '录入') {
                        if (this.TypeInForm.icon) {
                            this.handleRemove({ url: this.TypeInForm.icon })
                        }
                    }

                    this.$nextTick(_ => {
                        this.$refs.TypeInForm.resetFields()
                    });
                    this.TypeInForm = this.$options.data().TypeInForm
                    this.fileList = []
                    done();
                })
                .catch(_ => { });
        },
        // 图片部分
        handleRemove(file) {
            var path = ''
            if (file.response) {
                path = file.response.url
            } else {
                path = file.url
            }
            this.$axios.get('api/api3_city_park_del_ali_path', {
                params: {
                    path
                }
            }).then(({ data }) => {
                if (data.code === 200) {
                    this.TypeInForm.icon = ''
                    this.TypeInForm.origin_name = ''
                    this.$refs['uploadicon'].clearFiles()
                    if (file.response.data_id) {
                        this.updateIcon(file.response.data_id, file.response.data_index)
                    }
                } else {
                    this.$message.error(data.msg)
                }
            }).catch()
        },
        updateIcon(data_id, data_index) {
            this.$axios.put('api/api3_city_park_update_icon', {
                data_id
            }).then(({ data }) => {
                if (data.code === 200) {
                    this.tableData[data_index].icon = null
                    this.tableData[data_index].origin_name = null
                    this.tableData[data_index].path = null
                }
            }).catch()
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url
            this.dialogVisible = true
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type.includes('image')
            const isLt10M = file.size / 1024 / 1024 < 10;

            if (!isJPG) {
                this.$message.error('上传头像只能是图片格式!');
                return false
            }
            if (!isLt10M) {
                this.$message.error('上传头像图片大小不能超过 10MB!');
                return false
            }
        },
        handleUploadSuccess(res, file) {
            if (res['code'] === 1) {
                this.TypeInForm.icon = res['url']
                this.TypeInForm.origin_name = res['originName']
                this.temUrl = file.url
            } else {
                this.$refs['uploadicon'].clearFiles()
                this.$message.error(res['msg'])
            }
        },
        // 图片结束
        HandleResetForm(formName) {
            this.handleRemove({ url: this.TypeInForm.icon })
            this.$refs[formName].resetFields()
        },
        HandleSubmitEditForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.$axios
                        .put('api/api3_city_park_edit', this.TypeInForm)
                        .then(({ data }) => {
                            if (data.code === 200) {
                                Object.keys(this.tableData[this.editIndex]).forEach(key => (this.tableData[this.editIndex][key] = this.TypeInForm[key]))
                                this.tableData[this.editIndex]['path'] = this.temUrl
                                console.log(this.temUrl)
                                this.$refs[formName].resetFields()
                                this.$refs['uploadicon'].clearFiles()
                                this.TypeInDrawer = false
                                this.$message.success(data.msg)
                            } else {
                                this.$message.error(data.msg)
                            }
                        }).catch()
                } else {
                    return false
                }
            })
        },
        HandleSubmitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.$axios
                        .post('api/api3_city_park_store', this.TypeInForm)
                        .then(({ data }) => {
                            if (data.code === 200) {
                                this.loadTable()
                                this.$refs[formName].resetFields()
                                this.$refs['uploadicon'].clearFiles()
                                this.TypeInDrawer = false
                                this.$message.success(data.msg)
                            } else {
                                this.$message.error(data.msg)
                            }
                        }).catch()
                } else {
                    return false
                }
            })
        },
        loadTable() {
            this.$axios.get('api/api3_city_park_list?page=' + this.npage, {
                params: {
                    per_page: this.pageSize
                }
            }).then(({ data }) => {
                if (data.code === 200) {
                    this.tableData = data.data.data
                    this.total = data.data.total
                }
            }).catch()
        },
        handleSizeChange(val) {
            // console.log(`每页 ${val} 条`)
            this.npage = 1
            this.pageSize = val
            this.loadTable()
        },
        handleCurrentChange(val) {
            this.npage = val
            this.loadTable()
        },
        editListSortC(val) {
            let numReg = /^[0-9]*$/
            let numRe = new RegExp(numReg)
            if (val[this.needId].length > 0) {
                if (!numRe.test(val[this.needId])) {
                    this.$message.warning('请输入数字!')
                    return false
                }
            }
            this.$axios
                .put('api/api3_city_park_sort', {
                    val,
                    id: this.needId,
                })
                .then(({ data }) => {
                    if (data.code === 200) {
                        this.$nextTick(() => {
                            this.$refs[`list${this.needId}`].focus()
                            this.$refs[`list${this.needId}`].blur()
                        })
                        this.$message.success(data.msg)
                        this.loadTable()
                    }
                })
                .catch()
        },
        editListRadioC(e, id) {
            this.$axios
                .put('api/api3_city_park_if_display', {
                    e,
                    id,
                })
                .then(({ data }) => {
                    if (data.code === 200) {
                        // this.loadTable()
                        this.$message.success(data.msg)
                    }
                })
                .catch()
        },
        editRow(index, data) {
            this.TypeInDrawerTitle = '修改'
            this.TypeInDrawer = true
            this.TypeInForm.park = data[index].park
            this.TypeInForm.desc = data[index].desc
            this.TypeInForm.price = data[index].price
            if (data[index].icon) {
                this.fileList = [{ url: data[index].path, response: { url: data[index].icon, data_id: data[index].id, data_index: index } }]
            }
            this.TypeInForm.origin_name = data[index].origin_name
            this.TypeInForm.id = data[index].id
            this.editIndex = index
        }
    },
    watch: {
        tableData(n) {
            n.forEach((item) => {
                if (item.display === 2) {
                    this.ListIfDisplay[item.id] = true
                }
                this.listSort[item.id] = item.sort
            })
        },
        listSort: {
            handler(n) {
                if (this.timer_sort) {
                    clearTimeout(this.timer_sort)
                }
                this.timer_sort = setTimeout(() => {
                    this.$nextTick(() => {
                        this.editListSortC(n)
                    })
                }, 600)
            },
            deep: true,
        },
    },
    mounted() {
        this.loadTable()
    }
}
</script>

<style scoped>
.city-park {
    padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}

.el-drawer__wrapper>>>.el-drawer {
    overflow-y: auto;
}
</style>


// WEBPACK FOOTER //
// src/pages/miniProCCRMPConfig/CityPark.vue